// requires GSAP 3.10.0 or later
(function () {
  'use strict';

  var INIT_FLAG = '__blogReadCursorFollowInit';
  //@ts-ignore
  if (window[INIT_FLAG]) return;
    //@ts-ignore
  window[INIT_FLAG] = true;

  // The cursor-follow effect is a mousemove interaction and depends on GSAP.
  // On article + mobile the GSAP loader is intentionally skipped (see theme.liquid),
  // so GSAP never loads. Bail out at the same breakpoint to avoid waiting on a GSAP
  // that will never arrive (and which has no purpose on touch devices anyway).
  if (window.matchMedia('(max-width: 989px)').matches) return;

  function hasGsap() {
    // @ts-ignore
    return typeof gsap !== 'undefined';
  }
  //@ts-ignore
  function waitForGsap(cb) {
    if (hasGsap()) {
      cb();
      return;
    }
    // The GSAP loader dispatches `gsap:ready` once core + plugins are loaded
    // (theme.liquid). Wait on that event instead of polling every frame.
    document.addEventListener('gsap:ready', cb, { once: true });
  }

  waitForGsap(function () {
    /** @type {{ card: Element | null, button: HTMLElement | null, xTo: Function | null, yTo: Function | null }} */
    var state = {
      card: null,
      button: null,
      xTo: null,
      yTo: null,
    };

    function clearActive() {
      if (state.button) state.button.classList.remove('is-visible');
      state.card = null;
      state.button = null;
      state.xTo = null;
      state.yTo = null;
    }
  //@ts-ignore
    function setActive(card) {
      if (state.card === card) return;

      if (state.button) state.button.classList.remove('is-visible');

      var button = card ? card.querySelector('.blog-post-card__read-btn') : null;
      if (!button) {
        clearActive();
        return;
      }

      // @ts-ignore
      gsap.set(button, { xPercent: -50, yPercent: -50 });
      // @ts-ignore
      state.xTo = gsap.quickTo(button, 'x', { duration: 0.3, ease: 'power3.out' });
      // @ts-ignore
      state.yTo = gsap.quickTo(button, 'y', { duration: 0.3, ease: 'power3.out' });
      button.classList.add('is-visible');

      state.card = card;
      state.button = button;
    }

    window.addEventListener(
      'mousemove',
      function (event) {
        var target = event.target;
        if (!(target instanceof Element)) {
          clearActive();
          return;
        }

        var card = target.closest('.blog-post-card');
        if (!card) {
          clearActive();
          return;
        }

        setActive(card);

        if (state.xTo && state.yTo) {
          state.xTo(event.clientX);
          state.yTo(event.clientY);
        }
      },
      { passive: true }
    );
  });
})();

document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.blog-post-card__author').forEach((el) => {
    if (el.textContent.trim() === 'Shero Commerce DNR') {
      el.textContent = 'Shero';
    }
  });
});
